import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import type { RouteDef } from "./RouteDef";
import { RequestQueueRoutes } from "./RequestQueueRoutes";

export const PicoComRoutes = {
  DASHBOARD: { paths: { [LanguageEnum.CS]: "/", [LanguageEnum.EN]: "/" } },
  LOGIN: {
    paths: { [LanguageEnum.CS]: "/prihlaseni", [LanguageEnum.EN]: "/login" },
    aliases: ["/přihlášení"],
  },
  PROFILE: { paths: { [LanguageEnum.CS]: "/profil", [LanguageEnum.EN]: "/profile" } },
  ...RequestQueueRoutes,
} as const satisfies Record<string, RouteDef>;
